import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
class ApiEpShorturlBackend {
}
/**
 * Used to get backend shorturl provider
 */
ApiEpShorturlBackend.delete = ({ providerId, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/shorturl/backend/${providerId}`,
    method: "DELETE",
});
/**
 * Used to get backend shorturl provider
 */
ApiEpShorturlBackend.get = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/shorturl/backend/${id}?final_redirect_url=%2Fshorturl%2Fclose`,
    method: "GET",
});
/**
 * Used to get List backend shorturl providers
 */
ApiEpShorturlBackend.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/shorturl/backend?final_redirect_url=%2Fshorturl%2Fclose`,
    method: "GET",
});
export class ApiEpShorturl {
}
ApiEpShorturl.Backend = ApiEpShorturlBackend;
//# sourceMappingURL=shorturl.js.map